import lcmApiClient from "./lcmApiClient";
import { extractAccessRights } from "../extractors/accessRightsExtractor";

// @deprecated please do not use
/* istanbul ignore next */
export async function fetchAccessRights(type: $TSFixMe, id: $TSFixMe) {
  const param = {
    permitable_type: type,
    permitable_id: id,
  };
  return extractAccessRights(
    type,
    id,
    // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
    await lcmApiClient().get("/users/current/access_rights", param),
  );
}
